/** Format seconds as HH:MM:SS */
export function formatHms(totalSeconds) {
  if (totalSeconds == null || Number.isNaN(Number(totalSeconds))) return '—';
  const sec = Math.max(0, Math.round(Number(totalSeconds)));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString();
}

export function defaultAvailableUntilDateInput(days = 30) {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function visibilityLabel(v) {
  switch (String(v || '').toLowerCase()) {
    case 'public':
      return 'Public';
    case 'private':
      return 'Private';
    case 'disabled':
      return 'Disabled';
    default:
      return v || '—';
  }
}
